import * as React from 'react';
import classnames from 'classnames';
import { motion } from 'framer-motion';
import { Heading } from '@grandvisionhq/elements';
import { Icon } from '@grandvisionhq/icons';

const animations = {
    expanded: {
        height: 'auto',
        opacity: 1,
        transition: {
            ease: 'easeOut',
            duration: 0.15
        },
        overflow: 'visible',
        display: 'block'
    },
    collapsed: {
        height: '0px',
        opacity: 0,
        transition: {
            ease: 'easeIn',
            duration: 0.15
        },
        overflow: 'hidden',
        transitionEnd: {
            display: 'none'
        }
    }
};
const AccordionItem = ({ id , label , className , children , onClick , headingLevel ='h2' , expanded: expanded1 = false , variant ='normal' , fullWidth , headerComponent ,  })=>{
    const [isExpanded, setIsExpanded] = React.useState(expanded1);
    const [hasFocus, setHasFocus] = React.useState(false);
    const handleClick = React.useCallback(()=>{
        setIsExpanded((expanded)=>{
            onClick && onClick(!expanded);
            return !expanded;
        });
    }, []);
    const handleFocus = React.useCallback(()=>setHasFocus(true)
    , []);
    const handleBlur = React.useCallback(()=>setHasFocus(false)
    , []);
    // Allow prop updates to override the local state
    React.useEffect(()=>{
        if (expanded1 !== isExpanded) {
            setIsExpanded(expanded1);
        }
    }, [
        expanded1
    ]);
    return /*#__PURE__*/ React.createElement("section", {
        "data-t": "accordion-item",
        className: classnames(className, 'accordion-item', {
            [`accordion-item--${variant}`]: variant
        })
    }, /*#__PURE__*/ React.createElement("button", {
        id: `${id}-control`,
        className: classnames('accordion-item__head', {
            [`${className}__head`]: className,
            'accordion-item__head--full-width': fullWidth
        }),
        "aria-label": label,
        "aria-controls": id,
        "aria-expanded": isExpanded,
        onClick: handleClick,
        onFocus: handleFocus,
        onBlur: handleBlur
    }, headerComponent && headerComponent, label.length ? /*#__PURE__*/ React.createElement(Heading, {
        component: headingLevel,
        className: classnames('accordion-item__label', {
            [`${className}__label`]: className
        }),
        variant: "smallest"
    }, label) : null, /*#__PURE__*/ React.createElement(Icon, {
        name: isExpanded ? 'chevron-up' : 'chevron-down',
        className: classnames('accordion-item__icon', {
            [`${className}__icon`]: className
        }),
        height: 32,
        width: 32
    })), /*#__PURE__*/ React.createElement(motion.div, {
        id: id,
        className: classnames('accordion-item__body', {
            [`${className}__body`]: className,
            'accordion-item__body--full-width': fullWidth
        }),
        "aria-labelledby": `${id}-control`,
        "aria-hidden": !isExpanded,
        initial: animations.collapsed,
        animate: isExpanded ? animations.expanded : animations.collapsed
    }, children));
};
var AccordionItem$1 = AccordionItem;

export { AccordionItem, AccordionItem$1 as default };
//# sourceMappingURL=AccordionItem.js.map
